// 西班牙语
export default {
    login: {
        t01: 'Idioma',
        t02: 'Netflix',
        t03: 'Por favor ingrese su nombre de usuario',
        t04: 'Por favor ingrese su contraseña',
        t05: 'Iniciar sesión',
        t06: 'Registrarse',
        t07: 'Ingrese su número de teléfono',
        t08: 'Confirmar contraseña',
        t09: 'Introduzca el código de invitación',
        t10: 'Registrar cuenta',
        t11: 'Por favor confirme su contraseña',
        t13: 'El amor por el cine puede hacer que acumules una riqueza considerable sin darte cuenta.',
        t14: 'Inicio de sesión exitoso',
        t15: 'Las contraseñas no coinciden',
        t16: 'Registro exitoso',
        t17: 'Error de red',
        t18: 'Tiempo de espera superado, por favor verifique su conexión a la red'
    },
    cover_info: {
        t01: 'Comience a ganar',
        t02: 'Recargar monedas',
        t03: 'Retirar monedas',
        t04: 'Certificados'
    },
    cont: {
        t01: 'Seleccionar Idioma',
        t02: 'Todos',
        t03: 'Pendiente',
        t04: 'Completado',
        t05: 'Congelado',
        t06: 'Mi Saldo',
        t07: 'Incompleto',
        t08: 'Total de Pedidos',
        t09: 'Comisión',
        t10: 'Comisión Ganada',
        t11: 'Cantidad de Pedidos',
        t12: 'Saldo Disponible',
        t13: 'Comenzar a Robar Pedidos',
        t14: 'Fondos de la Cuenta',
        t15: 'Enviar Pedido',
        t16: 'Enviar Todos los Pedidos',
        t17: 'Hora de Robo de Pedidos',
        t18: 'Número de Pedido',
        t19: 'Valor Total del Pedido',
        t21: 'Obra',
        t22: 'Actor',
        t23: 'Comentarios sobre la obra',
        t24: 'Cancelar',
        t25: 'Por favor seleccione una calificación',
        t26: 'Envío de pedido completado',
        t27: 'Pedido Adquirido',
        t28: 'Robo de Pedidos Exitoso',
        t29: 'Falló el Robo de Pedidos, Intente Nuevamente!'
    }
    ,
    user: {
        t1: 'Código de referencia',
        t2: 'Saldo disponible',
        t3: 'Saldo disponible',
        t4: 'Beneficio total',
        t5: 'Retirar',
        t6: 'Historial de depósitos',
        t7: 'Historial de retiros',
        t8: 'Detalles de la cuenta',
        t9: 'Mensaje',
        t10: 'Conectar tarjeta bancaria',
        t11: 'Cambiar contraseña',
        t12: 'Cambiar contraseña para retirar',
        t13: 'Invitar amigos',
        t14: 'Selecciona un idioma',
        t15: 'Cerrar sesión',
        t16: 'Retirar',
        t17: 'Cantidad a retirar',
        t18: 'Nombre de la cuenta',
        t19: 'Número de teléfono',
        t20: 'Cantidad a retirar',
        t21: 'Retirar',
        t22: 'Introduce la cantidad a retirar',
        t23: 'Introduce tu contraseña para los fondos virtuales',
        t24: 'Total depositado',
        t25: 'Mensajes del sistema',
        t26: 'Detalles de la tarjeta bancaria',
        t27: 'Lista de bancos',
        t28: 'Nombre del banco',
        t29: 'Alias',
        t30: 'Número de tarjeta bancaria',
        t31: 'Número de teléfono',
        t32: 'Confirmar cambios',
        t33: 'Introduce el número de cuenta y el código IFSC de tu tarjeta bancaria conectada. Asegúrate de introducir correctamente tu nombre y número de teléfono, ya que si no lo haces, la cantidad depositada no se recibirá.',
        t34: 'Contraseña anterior',
        t35: 'Nueva contraseña',
        t36: 'Confirmar contraseña',
        t37: 'Continuar',
        t38: 'Recuerda tu contraseña. Si has olvidado tu contraseña, ponte en contacto con el servicio al cliente.',
        t39: 'Copiar enlace de invitación',
        t40: 'Invita a tus amigos para ganar más beneficios',
        t41: 'Depositar',
        t42: 'Confirmar',
        t43: 'Cancelar',
        t44: '¿Estás seguro de que quieres cerrar sesión?',
        t45: 'Cantidad depositada',
        t46: 'Se ha realizado el depósito correctamente',
        t47: 'Verificación completada',
        t48: 'En espera de verificación',
        t49: 'Total retirado',
        t50: 'Configura primero tu contraseña para retiros',
        t51: 'Introduce tu contraseña anterior',
        t52: 'Introduce tu nueva contraseña',
        t53: 'Confirma tu contraseña',
        t54: 'Las contraseñas introducidas no coinciden',
        t55: 'Copiado',
        t56: 'El monto del retiro no puede ser inferior a 30',
        t57: 'Envío exitoso, redirigiendo',
        t58: 'Revisión fallida',
        t59: 'Definir Avatar',
        t60: 'Definir Ahora',
        t61: 'Configuración exitosa',
        t62: 'Después de que se apruebe la billetera, necesita iniciar sesión para retirar dinero',
        t63: 'Retiro a tarjeta bancaria',
        t64: 'Retiro a USDT (proporción 1:0.013)',
        t65: 'Número de cuenta bancaria',
        t66: 'Por favor, introduce tu número de cuenta bancaria e IFSC code para la tarjeta bancaria que deseas vincular, así como tu nombre completo y número de móvil. Asegúrate de que toda la información sea precisa para facilitar las transacciones de pago.',
        t67: 'Por favor, vincula tu tarjeta bancaria primero',
        t68: 'Recarga del usuario',
        t69: 'Usuario aceptando pedidos',
        t70: 'Comisión de subordinados',
        t71: 'Retiro de dinero del usuario',
        t72: 'Transferir a Yebao',
        t73: 'Transferir desde Yebao',
        t74: 'Ganancias de Yebao',
        t75: 'Comisión por aceptar pedidos',
        t76: 'Saldo inferior a 30, no se puede continuar con la operación, por favor contacte al servicio de atención al cliente',
        t77: 'Por favor, ingrese el nombre del banco',
        t78: 'Por favor, ingrese el número de cuenta bancaria',
        t80: 'Por favor, ingrese su nombre completo',
        t81: 'Por favor, ingrese su número de teléfono',
        t82: 'Por favor, ingrese la cantidad de retiro',
        t83: 'Copiar',
        t84: 'Top 100 diario: Global',
        t85: 'Escuchar',
        "t86": "Correo electrónico",
        "t87": "Por favor, introduce tu correo electrónico",
        "t88": "Código bancario",
        "t89": "Por favor, introduce el código bancario",
        t90: 'Transferencia bancaria',
        t91: '1. No se cobra ninguna comisión por los retiros',
        t92: '2. El retiro se recibirá con éxito dentro de 10 a 15 minutos después de realizarlo. Para retiros fuera del horario laboral, se acreditará en el siguiente horario laboral.'
    },
    movie: {
        t01: 'Películas y programas de TV populares',
        t02: 'Contraseña de fondos',
        t03: 'Diferencia del pedido',
        t04: 'Gestión de direcciones on-chain',
        t05: 'Por favor, introduzca',
        t06: 'Por favor, introduzca la dirección on-chain correcta y la red correspondiente (p. ej., ERC20/TRC20/BTC); de lo contrario, el pago/la transferencia podría no llegar o provocar la pérdida de activos.',
        t07: 'Retirar a una dirección on-chain',
        t08: 'Por favor, añada',
        t09: 'Por favor, añada una dirección on-chain',
    },
    langType: '西班牙语'
}
